<script lang="ts">
import { stripSiteDomain } from '$lib/utils/url.js';
import { ETitleFontSizes } from '../../../config/enums';
import Link from '../../atoms/Link/Link.svelte';

let {
    mastheadTextColour = '',
    content = '',
    subContent = '',
    link = '',
    linkText = '',
    link2 = '',
    linkText2 = '',
    inverseButtonColours = false,
    headingLevel = 'h1',
    titleSize = ETitleFontSizes.H2,
} = $props();

// Transform URLs from Builder.io
const transformedLink = $derived(stripSiteDomain(link));
const transformedLink2 = $derived(stripSiteDomain(link2));
</script>

<div class="hero-text" style="--masthead-txt-colour: {mastheadTextColour};">
    {#if content}
        <svelte:element this={headingLevel} class="title title--{titleSize}">{content}</svelte:element>
    {/if}
    {#if subContent}
        <p class="sub-content">{subContent}</p>
    {/if}
    {#if transformedLink}
        <Link to={transformedLink} class="button {inverseButtonColours ? '' : 'button--inverse'}">
            {#snippet text()}
                {linkText}
            {/snippet}
        </Link>
    {/if}
    {#if transformedLink2}
        <Link to={transformedLink2} class="button {inverseButtonColours ? '' : 'button--inverse'}">
            {#snippet text()}
                {linkText2}
            {/snippet}
        </Link>
    {/if}
</div>

<style lang="scss">
    @use '/src/scss/global-constants/typography';
    @use 'sass-mq/mq' as *;

    .hero-text {
        bottom: var(--layout-pagegrid-margin);
        left: var(--layout-pagegrid-margin);
        position: absolute;
        right: var(--layout-pagegrid-margin);
    }

    .hero-text :global(.button) {
        display: inline-block;
        margin-right: 2rem;
        margin-top: 2.5rem;
        text-transform: uppercase;
    }

    .title {
        color: var(--masthead-txt-colour);
        display: flex;
        max-width: 30ch;
        text-align: left;
        text-transform: uppercase;
        text-wrap: balance;

        @include mq($from: desktop) {
            @include typography.display-hero;
        }

        &--h1 {
            @include typography.display-xl;
        }

        &--h1-5 {
            @include typography.display-hero;
        }

        &--h2 {
            @include typography.display-lg;
        }

        &--h3 {
            @include typography.display-md;
        }

        &--h4 {
            @include typography.heading-lg;
        }

        &--h5 {
            @include typography.heading-md;
        }
    }

    .sub-content {
        color: var(--masthead-txt-colour);
        margin: 2rem 0 0;

        @include mq($from: desktop) {
            margin: 3rem 0 0;
        }
    }
</style>
